import styled from 'styled-components'
import TextLink from 'components/TextLink'
import { themeGet } from 'styled-system'
import { Button } from 'reactstrap'

export const StyledButton = styled(Button)`
  borderradius: 0.125rem;
`

export const ReportLinkWrapper = styled.div`
  display: flex;
  flex: 0 1 30%;
  min-width: 12rem;
  justify-content: end;
  align-self: center;
  padding-left: 0.5rem;
  div {
    margin: 0;
    a {
      margin: 0;
      display: flex;
      align-items: center;
      font-size: 0.9rem;
      color: ${themeGet('colors.blue')} !important;
      text-decoration: none;
      cursor: pointer;

      &:hover,
      &:focus {
        text-decoration: underline;
        color: ${themeGet('colors.darkBlue')} !important;
      }
    }
  }
  a {
    color: ${themeGet('colors.blue')} !important;
    text-decoration: none;
    font-size: 0.9rem;
    cursor: pointer;

    &:hover,
    &:focus {
      text-decoration: underline;
      color: ${themeGet('colors.darkBlue')} !important;
    }
  }
`

export const ReportLink = styled(TextLink)`
  color: ${themeGet('colors.backgroundBody')};
  cursor: pointer;
  width: fit-content;
  &:focus,
  &:hover {
    text-decoration: underline;
    color: ${themeGet('colors.blue')};
  }
  font-size: 0.9rem;
  font-family: ${themeGet('fontFamily')};
`

export const SiteName = styled.h2`
  color: ${themeGet('colors.darkBlue')};
  font-size: 1.75rem;
  font-family: ${themeGet('headerFontFamilySemibold')};
  font-weight: 600;
  letter-spacing: 0.5;
  margin-bottom: 1rem;
`

export const LicenseHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 0.0625rem solid rgba(59, 59, 59, 1);
`

export const LicenseHeader = styled.h5`
  padding-bottom: 0;
  margin: 0;
  border-bottom: none;
  flex: 1 1 auto;
`

export const LicenseRow = styled.div<{ index?: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9375rem;
  border-bottom: 0.0625rem solid
    rgba(59, 59, 59, ${props => (props.index !== 0 ? '0.5' : '1')});
  padding: 0.75rem;
  width: 100%;

  p {
    margin: 0;
  }
`

export const LicenseName = styled.div`
  color: ${themeGet('colors.darkerDarkBlue')};
  font-family: ${themeGet('fontFamilySemibold')};
  flex: 0 1 50%;
  font-size: 0.9rem;
`

export const Expiration = styled.p`
  color: ${themeGet('colors.darkerDarkBlue')};
  font-family: ${themeGet('fontFamily')};
  padding-left: 0.5rem;
  flex: 0 1 20%;
  text-align: end;
  font-size: 0.9rem;
`

export const LicenseDetails = styled.div`
  margin-top: 0.5rem;
  color: ${themeGet('colors.darkerDarkBlue')};
  font-family: ${themeGet('fontFamily')};
  font-size: 0.85rem;
  line-height: 1.5;

  div {
    margin-bottom: 0.25rem;
    white-space: nowrap;
  }

  b {
    font-weight: 700;
    font-family: ${themeGet('fontFamilyBold')};
  }
`
